import { useParams } from 'react-router-dom'
import { useMemo } from 'react'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import { UserLoader } from '../UserLoader'
import { defaultValues, UserFormContextProvider } from '../utils/userFormContext'
import { defaultUserErrorValues, UserFormErrorContextProvider } from '../utils/userFormErrorContext'
import { RouterRouteId } from '../../../routers/_props'
import { useGetIdsHealthcareservicesHcsIdRequiredExpertsId } from '@toktokdoctech/tokapi-client'
import RequiredExpertForm from './RequiredExpertForm'
import { computeData } from './_utils'

const RequiredExpertEdition = () => {
    const currentHcs = useCurrentHcs()
    const params = useParams<RouterRouteId>()
    const userId = params.id ?? ''

    const { data, isLoading } = useGetIdsHealthcareservicesHcsIdRequiredExpertsId(currentHcs.id, userId, {
        query: { enabled: !!userId },
    })

    const transformedData = useMemo(() => (data ? computeData(userId, data) : undefined), [userId, data])

    return (
        <UserFormContextProvider initialValues={defaultValues}>
            <UserFormErrorContextProvider initialValues={defaultUserErrorValues}>
                {isLoading && <UserLoader />}
                {!isLoading && transformedData && <RequiredExpertForm mode="EDITION" data={transformedData} />}
            </UserFormErrorContextProvider>
        </UserFormContextProvider>
    )
}

export default RequiredExpertEdition
